import { h } from 'preact';
import { ProductCard } from './ProductCard';
import { SkeletonCard } from './SkeletonCard';
import styles from './ProductGrid.module.scss';
function getGridClassName(layout, filtersOpen) {
    let layoutClass = '';
    switch (layout.cardLayout) {
        case 'gridTwo':
            layoutClass = styles.productGridTwo;
            break;
        case 'gridFour':
            layoutClass = styles.productGridFour;
            break;
        case 'list':
            layoutClass = styles.productList;
            break;
        default:
            layoutClass = styles.productGridFour;
    }
    const needsFilterAdjustment = filtersOpen &&
        layout.filterLayout === 'filterSide' &&
        (layout.cardLayout === 'gridFour' || layout.cardLayout === 'gridTwo');
    return needsFilterAdjustment
        ? `${layoutClass} ${styles.productGridFourWithSideFilter}`
        : layoutClass;
}
export function ProductGrid({ products, loading, layout, filtersOpen = false }) {
    const finalClassName = getGridClassName(layout, filtersOpen);
    if (loading) {
        const skeletonCount = filtersOpen && layout.filterLayout === 'filterSide' ? 10 : 12;
        return (h("div", { class: finalClassName, "data-layout": layout.cardLayout, "data-filter-layout": layout.filterLayout }, Array.from({ length: skeletonCount }, (_, i) => (h(SkeletonCard, { key: i })))));
    }
    if (!products.length) {
        return h("p", { class: styles.noResults }, "No products found.");
    }
    return (h("div", { class: finalClassName, "data-layout": layout.cardLayout, "data-filter-layout": layout.filterLayout }, products.map(product => (h(ProductCard, { key: product.id, product: product, layout: layout.cardLayout })))));
}
